import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	closedSprintsLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	closedSprintsLabel: {
		id: 'issue-field-sprint-readview-full.sprint.closed-sprints.closed-sprints-label',
		defaultMessage: '{count} completed {count, plural, one {sprint} other {sprints}}',
		description: 'Header displayed in closed sprints dialog',
	},
});
export default messages;
